import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-emed-header',
  templateUrl: './emed-header.component.html',
  styleUrls: ['./emed-header.component.css'],
})
export class EmedHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
